import { render } from "./IconDownload.vue?vue&type=template&id=4c75e06e"
const script = {}
script.render = render

export default script